export const LOYALTY_PROGRAM_HVC_FLAG = 'enableLoyaltyProgramHvc';
export const ENABLE_LOYALTY_PROGRAM_HVC_PRODUCT_PAGE_EARN_LABEL =
  'enableLoyaltyProgramHvcProductPageEarnLabel';
